export class CloudResourceConfiguration {
    'cdcBackup';
    'inventoryBackup';
    'dbBackupModeCdc';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cdcBackup",
            "baseName": "cdcBackup",
            "type": "CloudResourceConfigurationCdcBackup",
            "format": ""
        },
        {
            "name": "inventoryBackup",
            "baseName": "inventoryBackup",
            "type": "CloudResourceConfigurationInventoryBackup",
            "format": ""
        },
        {
            "name": "dbBackupModeCdc",
            "baseName": "dbBackupModeCdc",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudResourceConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
